import { motion } from "framer-motion";
import { IMG } from "@/lib/images";

export const PageHero = ({ eyebrow, title, text, children, image = IMG.hero }) => (
  <section className="relative overflow-hidden bg-gradient-to-b from-[#EAF1FB] to-white">
    <div className="mx-auto grid max-w-[1200px] items-center gap-8 px-5 lg:px-8 py-14 md:grid-cols-2 md:py-20">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        {eyebrow && (
          <p className="font-display text-[13px] font-bold uppercase tracking-[0.24em] text-[#1E5EDB]">{eyebrow}</p>
        )}
        <h1 className="mt-3 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[#0A2342] sm:text-5xl">
          {title}
        </h1>
        <span className="mt-5 block h-1 w-16 rounded-full bg-[#1E5EDB]" />
        {text && <p className="mt-5 max-w-md text-[16px] leading-relaxed text-[#5B6B7F]">{text}</p>}
        {children}
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 1.04 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative"
      >
        <div className="overflow-hidden rounded-2xl shadow-[0_25px_60px_-20px_rgba(10,35,66,0.4)]">
          <img src={image} alt="Solar panels" className="h-[300px] w-full object-cover md:h-[420px]" />
        </div>
      </motion.div>
    </div>
  </section>
);
